shvenergy.news = (function ($) {
	"use strict";

	function init() {
        $('.track-featured-news').on("click", (e) => {
            let target = e.target,
                articleContainer = target.closest(".column"),
                imageContainer = target.closest(".row").querySelectorAll(".column")[1],
                container = articleContainer.querySelector('h2') ? articleContainer : imageContainer,
                articleName = container ? container.querySelector('a.news__link').innerText : '';

            articleName = articleName ? articleName.trim() : '';

            shvenergy.tracking.trackRawEventData({
                'event': 'clickFeaturedArticle',
                'articleName': articleName
            });
        });

        $('.news-list-item a').on('click', (e) => {
            trackArticleClick(e);
        });

        $('.news-list-item a').on('auxclick', (e) => {
            trackArticleClick(e);
        });

        // Related article
        $('.news-link-track a:not(.tag)').on('click', (e) => {
            trackRelatedArticleClick(e);
        });

        $('.news-link-track a:not(.tag)').on('auxclick', (e) => {
            trackRelatedArticleClick(e);
        });

        function trackArticleClick(e) {
            let articleAnchor = e.target.closest('a'),
                aritcleTitle = articleAnchor.querySelector('.news-list-item__heading').innerText.trim();

            shvenergy.tracking.trackRawEventData({
                'event': 'clickArticle',
                'articleName': aritcleTitle
            });
        }

        function trackRelatedArticleClick(e) {
            let articleRow = e.target.closest('.row'),
                aritcleTitle = articleRow.querySelector('h3').innerText.trim();

            shvenergy.tracking.trackRawEventData({
                'event': 'clickArticle',
                'articleName': aritcleTitle
            });
        }
	}

	init();

})(jQuery);